import { getTrailerUrlForFilm, loadTrailerUrlForFilm } from '@vista/omnichannel-components-domain';
import { useEffect } from 'react';
/**
 * Loads the URL for the trailer of a given film.
 */
export const useFilmTrailerUrl = (film, onFilmTrailerUrlLoaded, onFilmTrailerUrlFailedToLoad) => {
    useEffect(() => {
        (async () => {
            if (film) {
                try {
                    await loadTrailerUrlForFilm(film);
                    onFilmTrailerUrlLoaded === null || onFilmTrailerUrlLoaded === void 0 ? void 0 : onFilmTrailerUrlLoaded();
                }
                catch (_a) {
                    onFilmTrailerUrlFailedToLoad === null || onFilmTrailerUrlFailedToLoad === void 0 ? void 0 : onFilmTrailerUrlFailedToLoad();
                }
            }
        })();
    }, [film, onFilmTrailerUrlFailedToLoad, onFilmTrailerUrlLoaded]);
    return film ? getTrailerUrlForFilm(film.id) : undefined;
};
